import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

import { getIsContinuing, getIsLoading, getIsRetryLoading } from 'app-components/flux/credit-profile/selectors';
import { rootUiActions } from 'app-components/flux/root-ui';

import StdDialog from 'components/Dialogs/StdDialog';
import { CREDIT_SCORE_VERIFICATION_LOADER_DIALOG_ID } from './actions';

const CreditScoreLoadingDialog: React.FC = () => {
  const isLoading = useSelector(getIsLoading);
  const isRetryLoading = useSelector(getIsRetryLoading);
  const isContinuing = useSelector(getIsContinuing);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoading && !isRetryLoading && !isContinuing) {
      dispatch(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_LOADER_DIALOG_ID));
    }
  }, [isLoading, isRetryLoading, dispatch, isContinuing]);

  return (
    <StdDialog open size='xs' disableBackdropClick showCloseButton={false}>
      <DialogContent>
        <Box display='flex' height={260} flexDirection='column' alignItems='center' justifyContent='center'>
          <CircularProgress size={90} sx={{ mb: 4 }} />
          <Typography variant='captionRegular'>Verifying...</Typography>
        </Box>
      </DialogContent>
    </StdDialog>
  );
};

export default CreditScoreLoadingDialog;
